import { ia } from 'lib/helpers/utility';
import { usePatientDashboardAppointments } from 'lib/hooks/queries/patients/usePatient';

import Typography from 'components/shared/Typography/Typography';

import UpcomingAppointment from './components/UpcomingAppointment';

const ReceiptUpcomingAppointments = ({ patientId, timezone }) => {
  const limit = 4;

  const { data } = usePatientDashboardAppointments({
    params: {
      patientId,
      limit,
      withCount: true,
      withal: { practitioner: true },
      status: ['approved']
    },
    options: {
      enabled: !!patientId
    }
  });

  const { appointments, count } = data || {};

  if (!ia(appointments)) return null;

  const offsetUpcomingCount = (count || 0) - limit;

  return (
    <div className="flex flex-col gap-3 px-2 md:px-6">
      <Typography variant="p" size="small" weight="medium" color="neutral-500">
        Upcoming Appointments
      </Typography>
      <div className="flex items-center gap-3 sm:flex-wrap">
        {appointments.map((appointment) => (
          <UpcomingAppointment key={appointment.id} appointment={appointment} timezone={timezone} />
        ))}
      </div>
      {offsetUpcomingCount > 0 && (
        <Typography variant="p" size="small" weight="medium" color="primary-600">
          + {offsetUpcomingCount} more appointments
        </Typography>
      )}
    </div>
  );
};

export default ReceiptUpcomingAppointments;
